module.exports = __webpack_public_path__ + "static/media/file-symlink.917abbca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/file-symlink.svg
// module id = 2997
// module chunks = 0